/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Avatar, Grid } from '@mui/material';
import { DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { AccessRoleDTO, AccessRoleFilterDTO, CompanyDTO, CompanyFilterDTO, UserDTO, ValueListDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';
import { useTranslation } from 'react-i18next';

interface ICompanyMaintenanceProps {
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const CompanyMaintenance: React.FC<ICompanyMaintenanceProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [mainActivityList, setMainActivityList] = useState<ValueListDTO[]>([]);
    const [businessRelationshipTypeList, setBusinessRelationshipTypeList] = useState<ValueListDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [unityTypeList, setUnityTypeList] = useState<ValueListDTO[]>([]);
    const [userList, setUserList] = useState<UserDTO[]>([]);
    const [ownerCompanList, setOnwerCompanyList] = useState<CompanyDTO[]>([]);
    const [companyDTO, setCompanyDTO] = useState<CompanyDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        setCompanyDTO({
            ...companyDTO,
            id: '',
            name: '',
            fullName: '',
            webSite: '',
            industryTypeId: '',
            statusId: '',
            typeId: '',
            avatar: '',
            unityTypeId: '',
            businessRelationshipTypeId: '',
            ownerCompanyId: userInfo.user.companyId
        } as CompanyDTO);

    }, [data]);

    useEffect(() => {
        if (isOpenMaintenance && companyDTO?.id != '') {
            handleListGetAll(ListId.corpsphere.company.mainActivityId, setMainActivityList);
            handleListGetAll(ListId.corpsphere.company.businessRelationshipTypeId, setBusinessRelationshipTypeList);
            handleListGetAll(ListId.corpsphere.company.statusId, setStatusList);
            handleListGetAll(ListId.corpsphere.company.unityTypeId, setUnityTypeList);

            handleResposibleCompanyGetAll();
            handleUserGetAllAsync();
            handleGetCompanyByIdAsync();

            handleGetPermission(ListId.corpsphere.companyId, setAccessRolePermissionDTO);
        }
    }, [data, isOpenMaintenance]);

    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync',accessRoleFilterDTO, setActionExecuted, setLoading, undefined,  setList,);
    }, []);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'value ASC'
        };
        GenericService.GetAllAsync1('parmsphere.valueList', valueListFilterDTO, setLoading, setList, showMessage);
    }, []);

    const handleResposibleCompanyGetAll = useCallback(async () => {
        const companyFIlterDTO: CompanyFilterDTO = {
            name: '',
            businessRelationshipTypeId: '',
            statusId: '',
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('corpsphere.company', companyFIlterDTO, setLoading, setOnwerCompanyList, showMessage);
    }, []);

    const handleUserGetAllAsync = useCallback(async () => {
        const userFilterDTO = {
            companyId: '',
        };
        GenericService.GetAllViewAsync1('authsphere.user', userFilterDTO, setActionExecuted, setLoading, setUserList, showMessage, false);
    }, []);

    const handleGetCompanyByIdAsync = useCallback(async () => {
        if(data && data.id){
            console.log('data', data);
            await GenericService.GetByIdAsync1('corpsphere.company', data.id, setLoading, setCompanyDTO, showMessage);
        }
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = companyDTO as CompanyDTO;

        if (companyDTO?.id === '' || companyDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('corpsphere.company', dto, setCompanyDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            if(!accessRolePermissionDTO?.allowUpdate) {
                showMessage(t('message.allowUpdate'), 'info');
                return;
            }
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('corpsphere.company', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [companyDTO]);

    const handleAvatarEditClick = () => {
        const fileInput = document.getElementById('avatar-input');
        fileInput?.click(); // Programmatically click the hidden file input
    };

    const handleAvatarChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            // Reduzir a imagem antes de atualizar o estado
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (e) => {
                const img = document.createElement('img');
                img.src = e.target?.result as string;

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    // Ajuste a largura e altura desejadas
                    canvas.width = 100;
                    canvas.height = 100;

                    ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

                    const newDataUrl = canvas.toDataURL('image/jpeg', 0.75);
                    setCompanyDTO({
                        ...companyDTO,
                        avatar: newDataUrl // atualiza o estado com a imagem reduzida
                    } as CompanyDTO);
                };
            };
        }
    };

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);

        if (type != 'success')
            setIsOpenMaintenance(true);
    }
    const actions: IDialogActions[] = [
        { id: 'save', text: t('company.maintenanceButton.save'), icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick, isClose: isOpenMaintenance },
        { id: 'close', text: t('company.maintenanceButton.close'), icon: 'close_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title={t('company.detailsName')}
                icon='domain_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'xl'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={2} >
                            <input
                                accept="image/*"
                                style={{ display: 'none' }}
                                id="avatar-input"
                                type="file"
                                onChange={handleAvatarChange}
                            />
                            <Avatar
                                style={{ width: '150px', height: '150px' }}
                                src={companyDTO?.avatar}
                                onClick={handleAvatarEditClick}
                                sx={{ cursor: 'pointer', border: 1 }}
                            />
                        </Grid>
                        <Grid item xs={12} md={10} >
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <TextFieldInput
                                        id='name'
                                        label={t('company.maintenance.name')}
                                        placeholder={t('company.maintenance.name')}
                                        value={companyDTO?.name}
                                        setValue={setCompanyDTO}
                                        obj={companyDTO}
                                        required={true}
                                        maxLength={200}
                                        autoFocus={true}
                                        // error={companyDTO?.name ? false : true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextFieldInput
                                        id='fullName'
                                        label={t('company.maintenance.fullName')}
                                        placeholder={t('company.maintenance.fullName')}
                                        value={companyDTO?.fullName}
                                        setValue={setCompanyDTO}
                                        obj={companyDTO}
                                        required={true}
                                        maxLength={200}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldInput
                                        id='code'
                                        label={t('company.maintenance.code')}
                                        placeholder={t('company.maintenance.code')}
                                        value={companyDTO?.code}
                                        setValue={setCompanyDTO}
                                        obj={companyDTO}
                                        required={true}
                                        maxLength={5}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <SelectField
                                        id='unityTypeId'
                                        label={t('company.maintenance.unityType')}
                                        placeholder={t('company.maintenance.unityType')}
                                        value={companyDTO?.unityTypeId}
                                        setValue={setCompanyDTO}
                                        obj={companyDTO}
                                        valueList={unityTypeList}
                                        required={true}
                                        hasNoneSelect={false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextFieldInput
                                        id='address'
                                        label={t('company.maintenance.address')}
                                        placeholder={t('company.maintenance.address')}
                                        value={companyDTO?.address}
                                        setValue={setCompanyDTO}
                                        obj={companyDTO}
                                        required={true}
                                        maxLength={200}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <SelectField
                                        id='businessRelationshipTypeId'
                                        label={t('company.maintenance.businessRelationshipType')}
                                        placeholder={t('company.maintenance.businessRelationshipType')}
                                        value={companyDTO?.businessRelationshipTypeId}
                                        setValue={setCompanyDTO}
                                        obj={companyDTO}
                                        valueList={businessRelationshipTypeList}
                                        required={true}
                                        hasNoneSelect={false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextFieldInput
                                        id='webSite'
                                        label={t('company.maintenance.webSite')}
                                        placeholder={t('company.maintenance.webSite')}
                                        value={companyDTO?.webSite}
                                        setValue={setCompanyDTO}
                                        obj={companyDTO}
                                        maxLength={200}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={5.35}>
                            <SelectField
                                id='mainActivityId'
                                label={t('company.maintenance.mainActivity')}
                                placeholder={t('company.maintenance.mainActivity')}
                                value={companyDTO?.mainActivityId}
                                setValue={setCompanyDTO}
                                obj={companyDTO}
                                valueList={mainActivityList}
                                required={true}
                                hasNoneSelect={false}
                                searchable={true}
                                labelKey='value'
                                valueKey='id'
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <SelectField
                                id='statusId'
                                label={t('company.maintenance.status')}
                                placeholder={t('company.maintenance.status')}
                                value={companyDTO?.statusId}
                                setValue={setCompanyDTO}
                                obj={companyDTO}
                                valueList={statusList}
                                required={true}
                                hasNoneSelect={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4.65}>
                            <SelectField
                                id='ownerCompanyId'
                                label={t('company.maintenance.ownerCompany')}
                                placeholder={t('company.maintenance.ownerCompany')}
                                value={companyDTO?.ownerCompanyId}
                                setValue={setCompanyDTO}
                                obj={companyDTO}
                                valueList={ownerCompanList}
                                required={true}
                                hasNoneSelect={false}
                            />
                        </Grid>
                        {companyDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label={t('company.maintenance.id')}
                                        value={companyDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label={t('company.maintenance.createdBy')}
                                        value={userList.find(x => x.id === companyDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label={t('company.maintenance.creationDateTime')}
                                        value={formatDateTime(String(companyDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label={t('company.maintenance.updatedBy')}
                                        value={userList.find(x => x.id === companyDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label={t('company.maintenance.updateDateTime')}
                                        value={formatDateTime(String(companyDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>

                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};
